import * as React from "react";
import { useOrderDetailsSummariesSlot, DeliveryMethod } from "@grandvisionhq/fun-orders";
import { Hooks as Hooks$1 } from "@grandvisionhq/pickup-points";
import { Hooks } from "@grandvisionhq/stores-v2";
import { getShippingMethodInfo } from "../../../../../../../../utils/utils/get-shipping-method-info.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useOrderDetails = (orderData, shippingMethodsAsides, labels) => {
  const orderDetailsSummaries = useOrderDetailsSummariesSlot(orderData);
  const [pickupLocation, setPickupLocation] = React.useState();
  const [storeDetailsQuery, storeDetailsQueryState] = Hooks.useStoreDetailsWithGlobalStoreId();
  const [getPickupPoints, pickupPointsQueryState] = Hooks$1.useGetPickupPoints();
  const pickupLocationCode = orderData?.serviceStore?.globalStoreId;
  const showInvoiceDetails = orderData?.invoice?.customerCode || orderData?.invoice?.secondaryEmail || orderData?.invoice?.customerVatId;
  const isPickupStoreDelivery = orderData?.deliveryMethod === DeliveryMethod.Pickup;
  const isPickupPointDelivery = orderData?.deliveryMethod === DeliveryMethod.PickupPoint;
  const isPickupDelivery = isPickupStoreDelivery || isPickupPointDelivery;
  const { features } = useCheckoutSettings();
  const shippingMethodInfo = getShippingMethodInfo(
    labels.summary,
    orderData?.deliveryMethod,
    shippingMethodsAsides
  );
  React.useEffect(() => {
    if (pickupLocationCode && isPickupStoreDelivery) {
      storeDetailsQuery(pickupLocationCode);
    }
  }, [isPickupStoreDelivery, pickupLocationCode, storeDetailsQuery]);
  React.useEffect(() => {
    if (pickupLocationCode && isPickupPointDelivery) {
      getPickupPoints({
        formState: {
          postalCode: orderData?.shippingAddress.postalCode,
          city: orderData?.shippingAddress.city || ""
        }
      });
    }
  }, [
    getPickupPoints,
    isPickupPointDelivery,
    orderData?.shippingAddress?.city,
    orderData?.shippingAddress?.postalCode,
    pickupLocationCode,
    storeDetailsQuery
  ]);
  React.useEffect(() => {
    if (storeDetailsQueryState.data) {
      setPickupLocation(storeDetailsQueryState.data);
    }
    if (pickupPointsQueryState?.pickupPoints?.length) {
      const selectedPickupPoint = pickupPointsQueryState.pickupPoints.find(
        (pickupPoint) => pickupPoint.globalPickupPointId === pickupLocationCode
      );
      if (selectedPickupPoint) {
        setPickupLocation(selectedPickupPoint);
      }
    }
  }, [pickupLocationCode, pickupPointsQueryState.pickupPoints, storeDetailsQueryState.data]);
  return {
    labels,
    shippingMethodInfo,
    isPickupDelivery,
    pickupLocation,
    orderDetailsSummaries,
    showInvoiceDetails,
    features
  };
};
export {
  useOrderDetails
};
//# sourceMappingURL=use-order-details.js.map
